import {Component} from '@angular/core';

@Component({
  selector: 'app-anue',
  templateUrl: './anue.component.html'
})
export class AnueComponent {

}
